import { useContext } from "react";
import ProjectCard from "../components/ProjectCard";
import { ProjectsContext } from "../context/ProjectsContext";
import Footer from "./Footer";

const Projects = () => {
    const { projects, isLoading, hasError } = useContext(ProjectsContext);

    return (
        <>
            <section className="px-4 py-16 transition-colors duration-300 sm:px-6 sm:py-20 lg:px-8 lg:py-28 bg-gradient-to-b from-slate-50 to-white dark:from-slate-950 dark:to-slate-900">
                <div className="mx-auto max-w-6xl">
                    <header className="mb-10 max-w-3xl sm:mb-14">
                        <div className="mb-3 flex items-center gap-3 text-sm font-bold uppercase tracking-wide text-blue-600 dark:text-blue-400">
                            <span>Selected work</span>
                            <span className="text-slate-400 dark:text-slate-500"></span>
                        </div>
                        <h1 className="mb-5 text-4xl font-bold text-slate-900 dark:text-white sm:text-5xl md:text-6xl">
                            Projects
                        </h1>
                        <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300 sm:text-xl">
                            A collection of things I have built, explored, and shared.
                        </p>
                    </header>

                    {isLoading ? (
                        <p className="py-10 text-center text-slate-600 dark:text-slate-300" role="status">
                            Loading projects...
                        </p>
                    ) : hasError ? (
                        <p className="py-10 text-center text-slate-600 dark:text-slate-300" role="status">
                            Projects are temporarily unavailable. Please try again later.
                        </p>
                    ) : projects.length > 0 ? (
                        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
                            {projects.map((project) => (
                                <ProjectCard key={project.id} project={project} />
                            ))}
                        </div>
                    ) : (
                        <p className="py-10 text-center text-slate-600 dark:text-slate-300">
                            No projects to show right now.
                        </p>
                    )}
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Projects;